import inViewport from "../../global/in-viewport";

const stopVideo = {
  init() {
    this.video = document.querySelectorAll("video");

    if (this.video.length) {
      this.video.forEach((element) => {
        inViewport.isInViewport(element) && element.play
          ? element.play && element.play()
          : element.currentTime !== 0 && element.pause();
      });
    }
  },

  load() {
    this.video = document.querySelectorAll("video");

    this.video.forEach((video) => {
      const source = video.querySelector("[data-src]");
      source.setAttribute("src", source.dataset.src);

      const content = video.innerHTML;
      video.innerHTML = content;

      this.init();
    });
  },

  onScrollInit() {
    window.addEventListener("scroll", () => {
      this.init();
    });
  },
};

export default stopVideo;
